export enum FormActionType {
    SET_CURRENT_STEP = "SUBMIT_MATCH_FORM_SET_CURRENT_STEP",
    SET_DROPDOWN_OPEN = "SUBMIT_MATCH_FORM_SET_DROPDOWN_OPEN",
    SET_MIN_SQ_FEET = "SUBMIT_MATCH_FORM_SET_MIN_SQ_FEET",
    SET_MAX_SQ_FEET = "SUBMIT_MATCH_FORM_SET_MAX_SQ_FEET",
    SET_FILTER_OPTION = "SUBMIT_MATCH_FORM_SET_FILTER_OPTION",
    SET_SELECTED_BRANDS = "SUBMIT_MATCH_FORM_SET_SELECTED_BRANDS",
    SET_SELECTED_CATEGORY = "SUBMIT_MATCH_FORM_SET_SELECTED_CATEGORY",
    SET_COMPARE_OPTION = "SUBMIT_MATCH_FORM_SET_COMPARE_OPTION",
    SET_SAMPLE_SIZE = "SUBMIT_MATCH_FORM_SET_SAMPLE_SIZE",
    SET_SELECTED_GEO_OPTION = "SUBMIT_MATCH_FORM_SET_SELECTED_GEO_OPTION",
    SET_SELECTED_GEO = "SUBMIT_MATCH_FORM_SET_SELECTED_GEO",
    SET_SELECTED_TIME_OPTION = "SUBMIT_MATCH_FORM_SET_SELECTED_TIME_OPTION",
    SET_REPORT_NAME = "SUBMIT_MATCH_FORM_SET_REPORT_NAME",
    RESET_EVERYTHING = "SUBMIT_MATCH_FORM_RESET_EVERYTHING",
    ADD_EXCLUDED_MAP_MARKERS = "SUBMIT_MATCH_FORM_ADD_EXCLUDED_MAP_MARKERS",
    REMOVE_EXCLUDED_MAP_MARKERS = "SUBMIT_MATCH_FORM_REMOVE_EXCLUDED_MAP_MARKERS",
    REPLACE_EXCLUDED_MAP_MARKERS = "SUBMIT_MATCH_FORM_REPLACE_EXCLUDED_MAP_MARKERS",
};

export type SubmitMatchFormAction<T> = {
    type: FormActionType;
    data: T;
};
